export function splitAssets(total: number, clientPercent: number) {
  const clientAmount = Math.round((total * clientPercent) / 100);
  const partnerAmount = total - clientAmount;
  return { clientAmount, partnerAmount };
}

export function splitFundingSourceFields(
  source: SelfFundingSource,
  clientPercent: number,
) {
  function split(value: number | null | undefined) {
    if (value == null) return null;
    return splitAssets(value, clientPercent);
  }

  const assets = split(source.existingAssetsValue);
  const contribution = split(source.monthlyContributionAmount);
  const income = split(source.monthlyIncome);
  const drawdown = split(source.drawdownAmount);

  return {
    clientOverrides: {
      ...(assets && { existingAssetsValue: assets.clientAmount }),
      ...(contribution && { monthlyContributionAmount: contribution.clientAmount }),
      ...(income && { monthlyIncome: income.clientAmount }),
      ...(drawdown && { drawdownAmount: drawdown.clientAmount }),
    },
    partnerOverrides: {
      ...(assets && { existingAssetsValue: assets.partnerAmount }),
      ...(contribution && { monthlyContributionAmount: contribution.partnerAmount }),
      ...(income && { monthlyIncome: income.partnerAmount }),
      ...(drawdown && { drawdownAmount: drawdown.partnerAmount }),
    },
  };
}

export function captureOriginalMonetaryValues(source: SelfFundingSource): Record<string, number> {
  const values: Record<string, number> = {};
  if (typeof source.existingAssetsValue === 'number') values.existingAssetsValue = source.existingAssetsValue;
  if (typeof source.monthlyContributionAmount === 'number') values.monthlyContributionAmount = source.monthlyContributionAmount;
  if (typeof source.monthlyIncome === 'number') values.monthlyIncome = source.monthlyIncome;
  if (typeof source.drawdownAmount === 'number') values.drawdownAmount = source.drawdownAmount;
  return values;
}

export function findPartnerLinkedSource(
  partnerSelfFunding: Record<string, SelfFundingSource> | undefined,
  groupId: string,
): [string, SelfFundingSource] | undefined {
  if (!partnerSelfFunding) return undefined;
  return Object.entries(partnerSelfFunding).find(
    ([, ps]) => ps.fundingSourceGroupId === groupId,
  );
}
